import { render, staticRenderFns } from "./EditInvoices.vue?vue&type=template&id=ec1edc1a"
import script from "./EditInvoices.vue?vue&type=script&lang=js"
export * from "./EditInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports